<template>
  <div class="event-sponsor-banner padding--top-10">
    <div class="overflow-hidden position-relative">
      <background-image
        v-if="sponsorBanner && sponsorBanner.handle"
        :scale="'original'"
        :url="`https://media.graphassets.com/resize=w:1340,fit:crop/output=format:jpg/quality=value:70/compress/${sponsorBanner.handle}`"
        :loaded="true"
        :scrollScale="false"
        :preloadWhite="true"/>
    </div>
  </div>
</template>

<script>
import BackgroundImage from '@/components/layout/BackgroundImage';
export default {
  name: 'EventSponsorBanner',
  components: { BackgroundImage },
  props: {
    sponsorBanner: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
